import {httpGetProjectValidators, HttpGetProjectValidatorsResponse} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetProjectValidatorsOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<
        UseQueryOptions<HttpGetProjectValidatorsResponse, AxiosError<ErrorResponseData>>,
        'queryKey' | 'queryFn'
    >
}

export const useGetProjectValidators = ({urlParams, options}: UseGetProjectValidatorsOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT_VALIDATORS, urlParams.projectId],
        queryFn: () => httpGetProjectValidators({urlParams}),
        ...options
    })
